import {
  GET_TESTS,
  GET_TESTS_SUCCEEDED,
  GET_TESTS_FAILED,
  ADD_TEST,
  ADD_TEST_SUCCEEDED,
  ADD_TEST_FAILED,
  EDIT_TEST,
  EDIT_TEST_SUCCEEDED,
  EDIT_TEST_FAILED,
  DELETE_TEST,
  DELETE_TEST_SUCCEEDED,
  DELETE_TEST_FAILED,
  GET_MY_ATTEMPTED_TESTS,
  GET_MY_ATTEMPTED_TESTS_SUCCEEDED,
  GET_MY_ATTEMPTED_TESTS_FAILED,
  ENROL_MOCK_TEST,
  ENROL_MOCK_TEST_SUCCEEDED,
  ENROL_MOCK_TEST_FAILED,
} from './index';

export const getTests = () => {
  return {
    type: GET_TESTS,
    payload: {
      url: 'course/test/',
      onSuccess: GET_TESTS_SUCCEEDED,
      onFailure: GET_TESTS_FAILED,
    },
  };
};

export const addTest = (data = {}) => {
  return {
    type: ADD_TEST,
    payload: {
      data,
      url: 'course/test/',
      onSuccess: ADD_TEST_SUCCEEDED,
      onFailure: ADD_TEST_FAILED,
    },
  };
};

export const editTest = (data = {}, slug = {}) => {
  return {
    type: EDIT_TEST,
    payload: {
      data,
      url: `course/test/${slug}/`,
      onSuccess: EDIT_TEST_SUCCEEDED,
      onFailure: EDIT_TEST_FAILED,
    },
  };
};

export const deleteTest = (data = {}) => {
  return {
    type: DELETE_TEST,
    payload: {
      url: `course/test/${data}/`,
      onSuccess: DELETE_TEST_SUCCEEDED,
      onFailure: DELETE_TEST_FAILED,
    },
  };
};

export const getMyEnroledTests = (
  page = {},
  search = {},
  user = {},
  perPage = 10
) => {
  return {
    type: GET_MY_ATTEMPTED_TESTS,
    payload: {
      url: `enrol/mock-test-enroll/?page=${page}&per_page=${perPage}&search=${search}&user=${user}`,
      onSuccess: GET_MY_ATTEMPTED_TESTS_SUCCEEDED,
      onFailure: GET_MY_ATTEMPTED_TESTS_FAILED,
    },
  };
};

export const enrolMockTest = (data = {}) => {
  return {
    type: ENROL_MOCK_TEST,
    payload: {
      data,
      url: 'enrol/mock-test-enroll/',
      onSuccess: ENROL_MOCK_TEST_SUCCEEDED,
      onFailure: ENROL_MOCK_TEST_FAILED,
    },
  };
};
